/**
 * ピン画像登録
 * @param img 登録する画像
 * @param isAddPin true: before画像登録, false: after画像に登録
 */
export interface RegisterPinImage {
  img: Blob;
  isAddPin: boolean;
}

export interface ArticleDocuments {
  file_name: string,
  file_path: string,
  display_name: string,
  category: string
}

/**
 * ピンインポートAPIで返却されるピン情報
 */
export interface ResImportPin {
  id: string;
  before_image_id: string[];
  before_image_url: string[];
  after_image_id: string[];
  after_image_url: string[];
}

/**
 * ピンインポートAPIのレスポンス
 */
export interface ResImportPins {
  /** インポートしたピンの一覧 */
  pins: ResImportPin[];
  /** 旧ピンIDと新ピンIDの対応関係（旧ピンID: 新ピンID） */
  pin_id_map: { [oldPinId: string]: string };
  /** 旧before画像IDと新before画像IDの対応関係（旧before画像ID: 新before画像ID） */
  before_image_id_map: { [oldImageId: string]: string };
  /** 旧after画像IDと新after画像IDの対応関係（旧after画像ID: 新after画像ID） */
  after_image_id_map: { [oldImageId: string]: string };
}

/**
 * ピンのレスポンス
 */
export interface ResRegisterPin {
  pin: {
    id: string;
    before_image_id: string[];
    before_image_url: string[];
    after_image_id: string[];
    after_image_url: string[];
  }
}

/**
 * 画像保存
 */
export interface ResSaveImage {
  documents: { file_id: string, file_path: string }
}

/**
 * 保存用 - 保存画像種類
 */
/** 画像種別 */
export const ImageType = {
  /** 画像分類 */
  Category: 1,

  /** 添付写真 */
  AttachedPhoto: 2,

  /** ピン画像（360度パノラマ画像） */
  PinPanorama: 3,
} as const;

/** 画像種別の型（1 | 2 | 3） */
export type ImageType = (typeof ImageType)[keyof typeof ImageType];